import { useComputeCropInfoBoxData } from '@modules/encoding/modules/rotation/helpers/useComputeCropInfoBoxData';

export const useSelectedCropLogic = ({ farmSeasonCropId }: { farmSeasonCropId: number }) => {
    const { computeCropInfoBoxData } = useComputeCropInfoBoxData();
    const computedCrop = computeCropInfoBoxData({ farmSeasonCropId });

    return { crop: computedCrop };
};
